"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

var _toConsumableArray2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray"));

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.regexp.search");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _moment = _interopRequireDefault(require("moment"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _elDragDialog = _interopRequireDefault(require("@/directive/el-drag-dialog"));

var _qrcodejs = _interopRequireDefault(require("qrcodejs2"));

var _lang = _interopRequireDefault(require("@/lang"));

var _vuex = require("vuex");

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// secondary package based on el-pagination
// base on element-ui
// Custom Table Column Mixins (Omega Theme)
var _default = {
  name: "user:view",
  mixins: [_CustomTableColumn.default],
  extends: _PermissionPage.default,
  components: {
    Pagination: _Pagination.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    elDragDialog: _elDragDialog.default
  },
  data: function data() {
    return {
      searchSelected: "",
      viewOnly: false,
      paginationOptions: {
        page: 1,
        limit: 10
      },
      showDialog: false,
      dialogType: '',
      allDepartments: [],
      allRoles: [],
      roles: [],
      tableData: [],
      totalData: 0,
      search: "",
      formData: {
        roleId: []
      },
      formTitle: "",
      formButton: "",
      checkedItems: null,
      googleDialog: false,
      loading: true,
      qrcode: null
    };
  },
  created: function created() {
    this.fetchData();
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['searchOptions']), {
    errorInfo: function errorInfo() {
      return {
        emptyUserName: this.$t('system.user.username') + this.$t('SMS.canNotBeEmpty'),
        invalidAccountNameLength: this.$t('message.message76'),
        invalidAccountName: this.$t('message.message74')
      };
    },
    rules: function rules() {
      var _this2 = this;

      var checkAccountFormat = function checkAccountFormat(rule, value, callback) {
        var length;
        var minlength = 6;
        var maxlength = 20;

        if (_this2.dialogType === 'edit') {
          return callback();
        }

        if (!value) {
          return callback(new Error(_this2.errorInfo.emptyUserName));
        }

        length = value.length;

        if (length < minlength || length > maxlength) {
          return callback(new Error(_this2.errorInfo.invalidAccountNameLength));
        }

        if (/.*[\u4e00-\u9fa5|\！|\，|\。|\（|\）|\《|\》|\“|\”|\？|\：|\；|\【|\】]+.*/.test(value)) {
          return callback(new Error(_this2.errorInfo.invalidAccountName));
        } else {
          return callback();
        }
      };

      return {
        username: [{
          required: true,
          validator: checkAccountFormat,
          trigger: "blur"
        }],
        mobile: [{// type: "number",
          // message: "Please insert a valid phone number",
          // trigger: "blur"
        }],
        email: [{
          type: "email",
          message: _lang.default.t('common.emailFormat'),
          trigger: "blur"
        }],
        roleId: [{
          required: true,
          message: _lang.default.t('system.userAdd.role') + _lang.default.t('SMS.canNotBeEmpty'),
          trigger: "blur"
        }],
        status: [{
          required: true,
          message: _lang.default.t('system.userAdd.status') + _lang.default.t('SMS.canNotBeEmpty'),
          trigger: "blur"
        }],
        sex: [{
          required: true,
          message: _lang.default.t('system.userAdd.gender') + _lang.default.t('SMS.canNotBeEmpty'),
          trigger: "blur"
        }]
      };
    }
  }),
  methods: {
    fetchData: function fetchData() {
      var _this3 = this;

      var _this = this;

      _this.loading = true;
      var status = "";

      if (this.searchSelected == "0") {
        status = "0";
      } else if (this.searchSelected == "1") {
        status = "1";
      }

      _httpUtils.default.post("user", "list", null, {
        pageNum: _this.paginationOptions.page,
        pageSize: _this.paginationOptions.limit,
        username: _this.search,
        status: status
      }).then(function (res) {
        // _this.$store.dispatch('tagsView/addCache', {
        //
        //   tagPath: this.$route.path,
        //   cache: res
        // })
        if (res.code == 200) {
          _this.tableData = res.data.rows; // console.log(res.data.rows);

          _this.totalData = res.data.total;
        } else {
          _this.$notify({
            title: _this3.$t("common.error"),
            message: _this3.$t("common.fetchError"),
            type: "error"
          });
        }

        _this.loading = false;
      }).catch(function (err) {
        _this.$notify({
          title: _this3.$t("common.error"),
          message: _this3.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });

        _this.loading = false;
      });

      _httpUtils.default.post("role", "getAllRoles", null, {}).then(function (res) {
        if (res.code == 200) {
          _this.allRoles = res.data;
        }
      }).catch(function (err) {
        _this.$notify({
          title: _this3.$t("common.error"),
          message: _this3.$t("SMS.error") + ',' + err.message,
          type: "error"
        });
      });

      _httpUtils.default.post("dept", "select/tree", null, {}).then(function (res) {
        _this.allDepartments = res; // console.log(res);
      }).catch(function (err) {
        _this.$notify({
          title: _this3.$t("common.error"),
          message: _this3.$t("SMS.error") + ',' + err.message,
          type: "error"
        });
      });
    },
    addData: function addData(data) {
      var _this4 = this;

      var _this = this;

      data.status = '1';

      _httpUtils.default.post("user", "add", null, data).then(function (res) {
        if (res.code == 200) {
          _this.fetchData();

          _this.closeDialog();

          _this.$notify({
            title: _this.$t("common.success"),
            message: _this.$t("system.userAdd.userAddFormSubmit.success"),
            type: "success"
          });
        } else {
          _this.$notify({
            title: _this.$t("common.error"),
            message: res.message,
            type: "error"
          });
        }
      }).catch(function (err) {
        _this.$notify({
          title: _this4.$t("common.error"),
          message: _this4.$t("SMS.error") + ',' + err.message,
          type: "error"
        });
      });
    },
    updateData: function updateData(data) {
      var _this5 = this;

      var _this = this;

      _httpUtils.default.post("user", "update", null, data).then(function (res) {
        if (res.code == 200) {
          _this.fetchData();

          _this.closeDialog();

          _this.$notify({
            title: _this.$t("common.success"),
            message: _this.$t("system.user.table.edit.updateUser"),
            type: "success"
          });
        } else {
          _this.$notify({
            title: _this.$t("common.error"),
            message: res.message,
            type: "error"
          });
        }
      }).catch(function (err) {
        _this.$notify({
          title: _this5.$t("common.error"),
          message: _this5.$t("SMS.error") + ',' + err.message,
          type: "error"
        });
      });
    },
    deleteData: function deleteData(data) {
      var _this6 = this;

      var _this = this;

      _httpUtils.default.post("user", "delete", null, data).then(function (res) {
        if (res.code == 200) {
          _this.fetchData();

          _this.$notify({
            title: _this.$t("common.success"),
            message: _this.$t("system.user.deleteUsers.success"),
            type: "success"
          });
        } else {
          _this.$notify({
            title: _this.$t("common.error") + ',' + err.message,
            message: res.message,
            type: "error"
          });
        }
      }).catch(function (err) {
        _this.$notify({
          title: _this6.$t("common.error"),
          message: _this6.$t("SMS.error") + ',' + err.message,
          type: "error"
        });
      });
    },
    handleSearch: function handleSearch() {
      this.paginationOptions.page = 1;
      this.paginationOptions.limit = 10;
      this.fetchData();
    },
    handleDialog: function handleDialog(cmd, id) {
      var _this7 = this;

      this.initForm(cmd);
      this.fetchData();

      if (cmd == "view") {
        this.viewOnly = true;
        this.fillForm(id);
      }

      if (cmd == "edit") {
        this.fillForm(id);
      }

      this.$nextTick(function (_) {
        _this7.showDialog = true;
      });
    },
    handleGoogleDialog: function handleGoogleDialog(row) {
      var _this8 = this;

      var _this = this;

      this.googleDialog = true;

      _httpUtils.default.post("user", "getUserGoogleKey", null, row.username).then(function (res) {
        var url = res.googleQrcode;

        _this8.$nextTick(function () {
          if (_this8.qrcode) {
            _this8.qrcode.makeCode(url);
          } else {
            _this8.qrcode = new _qrcodejs.default("qrcode", {
              text: url,
              width: 220,
              height: 220,
              colorDark: "#000000",
              colorLight: "#ffffff",
              correctLevel: _qrcodejs.default.CorrectLevel.H
            });
          }
        });
      }).catch(function (err) {
        _this.$notify({
          title: _this8.$t("common.error"),
          message: _this8.$t("SMS.error") + ',' + err.message,
          type: "error"
        });
      });
    },
    handlePagination: function handlePagination(newOptions) {
      var _this9 = this;

      this.paginationOptions = newOptions;
      this.$nextTick(function () {
        return _this9.fetchData();
      });
    },
    handleRecover: function handleRecover() {
      var _this10 = this;

      if (this.checkSelection()) {
        return;
      }

      var _this = this;

      var ids = '';

      for (var data in this.checkedItems) {
        ids = ids === "" ? this.checkedItems[data].username.toString() : ids.concat(',' + this.checkedItems[data].username.toString());
      }

      _httpUtils.default.post("user", "password/reset", null, ids).then(function (res) {
        if (res.code == 200) {
          _this.fetchData(); // this.$alert({
          //   title: _this.$t("common.success"),
          //   message: _this.$t("system.user.userTable.resetSuccess") + res.message + _this.$t("system.user.userTable.resetSuccessInfo"),
          //   type: "success"
          // });


          _this10.$alert(_this.$t("system.user.userTable.resetSuccess") + " " + res.message + " " + _this.$t("system.user.userTable.resetSuccessInfo"), _this.$t("common.success"), {
            confirmButtonText: _this.$t("common.confirm")
          });
        } else {
          _this.$notify({
            title: _this.$t("common.error"),
            message: res.message,
            type: "error"
          });
        }
      }).catch(function (err) {
        _this.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    handleSubmit: function handleSubmit() {
      var _this11 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          var dummy = (0, _objectSpread2.default)({}, _this11.formData);
          var roleId = "";
          var temp = (0, _toConsumableArray2.default)(dummy.roleId);

          for (var i = 0; i < temp.length; i++) {
            if (i == 0) {
              roleId = temp[i];
            } else {
              roleId = roleId + "," + temp[i];
            }
          }

          dummy.roleId = roleId;

          if (dummy.deptId) {
            var deptId = (0, _toConsumableArray2.default)(dummy.deptId);
            dummy.deptId = deptId.splice(-1)[0];
          }

          _this11.$nextTick(function () {
            if (dummy.userId) {
              _this11.updateData(dummy);
            } else {
              _this11.addData(dummy);
            }
          });
        }
      });
    },
    handleDelete: function handleDelete(userIds) {
      var _this12 = this;

      this.$confirm(this.$t("system.user.userTable.confirmDelete"), this.$t("common.warning"), {
        confirmButtonText: this.$t("common.delete"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning"
      }).then(function () {
        return _this12.deleteData([userIds]);
      }).catch(function () {
        return null;
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.checkedItems = val;
    },
    handleMultipleDelete: function handleMultipleDelete() {
      var _this13 = this;

      var temp = this.checkedItems;

      if (!temp) {
        this.$notify({
          title: this.$t("common.error"),
          message: this.$t("system.user.userTable.deleteWarn"),
          type: "error"
        });
        return;
      }

      var userIds = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = temp[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var data = _step.value;
          userIds.push(data.userId);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$confirm(this.$t("system.user.userTable.confirmDelete"), this.$t("common.warning"), {
        confirmButtonText: this.$t("common.delete"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning"
      }).then(function () {
        return _this13.deleteData(userIds);
      }).catch(function () {
        return null;
      });
    },
    initForm: function initForm(cmd) {
      if (cmd == "add") {
        this.formTitle = this.$t("system.user.userTable.newUsers");
        this.formButton = this.$t("common.add");
        this.dialogType = 'add';
      } else if (cmd == "edit") {
        this.formTitle = this.$t("system.user.table.edit.updateUser");
        this.formButton = this.$t("common.edit");
        this.dialogType = 'edit';
      } else if (cmd == "view") {
        this.formTitle = this.$t("system.user.table.detail.userInfo");
        this.dialogType = 'view';
      }

      this.viewOnly = false;
    },
    findItemById: function findItemById(items, itemId) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          if (item.id === itemId) {
            return item;
          }

          if (item.hasChild) {
            var result = this.findItemById(item.children, itemId);
            if (result) return result;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    findAllParentIds: function findAllParentIds(item) {
      var results = [];
      results.push(item.id);

      if (item.hasParent) {
        var parentItem = this.findItemById(this.allDepartments, item.parentId);
        results.push.apply(results, (0, _toConsumableArray2.default)(this.findAllParentIds(parentItem)));
      }

      return results;
    },
    fillForm: function fillForm(id) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.tableData[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var data = _step3.value;

          if (data.userId === id) {
            var deptId = [];

            if (data.deptId) {
              var itemObj = this.findItemById(this.allDepartments, data.deptId.toString());
              deptId = (0, _toConsumableArray2.default)(this.findAllParentIds(itemObj));
              deptId.reverse();
            }

            var roleId = [];

            if (data.roleId) {
              var roleIds = data.roleId.split(",");
              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = roleIds[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var _id = _step4.value;
                  roleId.push(parseInt(_id));
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                    _iterator4.return();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }
            }

            this.formData = {
              userId: data.userId,
              username: data.username,
              mobile: data.mobile,
              email: data.email,
              roleId: roleId,
              deptId: deptId,
              status: data.status,
              sex: data.sex,
              description: data.description
            };
            return;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    checkSelection: function checkSelection() {
      var message, info;

      if (this.checkedItems === undefined ? true : this.checkedItems === null ? true : this.checkedItems.length === 0) {
        message = _lang.default.t("message.message16");
        info = _lang.default.t("SMS.alarm");
        this.$message(message, info, {
          confirmButtonText: _lang.default.t("permission.confirm"),
          type: "warning"
        });
        return true;
      }
    },
    closeDialog: function closeDialog() {
      var _this14 = this;

      this.showDialog = false;
      this.formData = {
        roleId: []
      };
      this.$nextTick(function () {
        return _this14.$refs["dataForm"].clearValidate();
      });
    },
    dateFormat: function dateFormat(date) {
      if (date == undefined) {
        return "";
      }

      return (0, _moment.default)(date).format("YYYY-MM-DD HH:mm:ss");
    }
  }
};
exports.default = _default;